import React from 'react';
import {
	NavLink,
	Link
} from 'react-router-dom'


import Logo from './../inc/Logo';
import LogoSVG from './../inc/LogoSVG';
import Header from './../inc/Header';
import Footer from './../inc/Footer';
import Loader from './../inc/Loader';
import Menu from './../inc/Menu';
import MenuToggleBtn from './../inc/MenuToggleBtn';

import Hero from './Hero';
// import Intro from './Intro';

import ProjectNav from './../Projects/ProjectNav';
import ProjectGrid from './../Projects/Grid/ProjectGrid';
import ProjectSelectedGrid from './../Projects/Selected/ProjectSelectedGrid';

import { fetchMenu } from "./../../actions/menuActionCreators";
import { fetchPage } from "./../../actions/pageActionCreators";
import { fetchOptions } from "./../../actions/optionActionCreators";
import { fetchProjects } from "./../../actions/projectActionCreators";
import { fetchPosts } from "./../../actions/postActionCreators";
//import { fetchHomepageSliders } from "./../../actions/homepagesliderActionCreators";
// import ReactFullpage from '@fullpage/react-fullpage';
import ScrollToTop from './../inc/ScrollToTop';


const page_id = '8';

class Index extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			pageLoading: true
		}
	}
	componentWillMount() {
		let before = performance.now();
		let _this = this;
		Promise.all([
			this.props.dispatch(fetchMenu('menu')),
			this.props.dispatch(fetchPage(page_id)),
			this.props.dispatch(fetchProjects()),
			this.props.dispatch(fetchOptions()),
		]).then(() => {
			let after = performance.now();
			let diff = after-before;
			let media_length = process.env.REACT_APP_ANIMATION_DURATION;
			if(diff < media_length){
				setTimeout(() => {
					_this.setState({
						pageLoading: false
					})
				},(media_length - diff))
			}else{
				_this.setState({
					pageLoading: false
				})
			}
			
		});
	}

	render() {
		let _this = this;
		let { menu } = this.props.menu;
		let category = this.props.match.params.category ? this.props.match.params.category : 'selected';
		let {initCat} = this.state;
		let loadedProjects = this.props.projects && Object.keys(this.props.projects.data).length ? this.props.projects.data.all : [];
		let loadedCategories = this.props.projects && Object.keys(this.props.projects.data).length ? this.props.projects.data.categories : [];
		console.log(this.props)
		
		let catData = loadedCategories && loadedCategories.filter((cat, key) => {
			return cat.slug == category;
		});
		//console.log(loadedProjects);
		if(!catData.length) return [];

		let filteredProjects = loadedProjects.filter((project, key) => {
			return project.categories.some((cat) => {
				return cat.slug == category;
			})
		})
		// const Fullpage = () => (
		// 	<ReactFullpage
		// 		// scrollOverflow={true}
		// 		// licenseKey={process.env.REACT_APP_FULLPAGE_LICENSE}
		// 		// offsetSections={true}
		// 		// responsiveWidth={process.env.REACT_APP_FULLPAGE_BREAKPOINT}
		// 		// scrollingSpeed={500}
		// 		// css3={true}
				
		// 		autoScrolling={false}
        //         onLeave={
        //             function (origin, destination, direction) {
		// 				let logo = document.querySelector('.mole-logo');
		// 				let menu = document.querySelector('.btn--menu');
		// 				let menuBtn = document.querySelector('header .btn-menu--label');
        //             	(destination.item.dataset.logo) ? logo.classList.add('hidden') : logo.classList.remove('hidden');
		// 				(destination.isLast) ? menuBtn.classList.add('only-') : menuBtn.classList.remove('only-');
        //             }
        //         }
		// 		render={({ state, fullpageApi }) => {
		// 			return (
		// 				<ReactFullpage.Wrapper>
		// 					{
		// 						!this.state.pageLoading &&
		// 						<Hero {..._this.props} fullpageApi={fullpageApi} page_id={page_id} />

		// 					}
							
		// 					{/* <Intro {..._this.props} fullpageApi={fullpageApi} /> */}

		// 					<section className="section" data-logo="hide">
		// 						<Link to={`${process.env.PUBLIC_URL}/`} className="mole-logo">
		// 							<LogoSVG/>
		// 						</Link>
		// 						<ProjectNav  {..._this.props} loadedCategories={loadedCategories} category={catData[0]} type='grid' />
		// 						<ProjectSelectedGrid {..._this.props}  loadedProjects={loadedProjects} filteredProjects={filteredProjects} />
		// 					</section>

		// 					<Footer  {..._this.props} />
							
		// 					<MenuToggleBtn {..._this.props} fullpageApi={fullpageApi} />
		// 				</ReactFullpage.Wrapper>
		// 			)
		// 		}}
		// 	/>
		// );

		return (
			<main className="mole__home" >
				{this.state.pageLoading &&
					<Loader />
				} 
				<ScrollToTop />
				<Header headerPos={'absolute'} {..._this.props} />
				{/* <Fullpage {..._this.props} /> */}
				
				<Hero {..._this.props} page_id={page_id} />


				<section className="section" data-logo="hide">
					<Link to={`${process.env.PUBLIC_URL}/`} className="mole-logo">
						<LogoSVG/>
					</Link>
					<ProjectNav  {..._this.props} loadedCategories={loadedCategories} category={catData[0]} type='grid' />
					<ProjectSelectedGrid {..._this.props}  loadedProjects={loadedProjects} filteredProjects={filteredProjects} />
				</section>

				
				{!this.state.pageLoading &&
					<Menu {..._this.props}/>
				}
				<Footer {..._this.props}/>
			</main>
		);
	}
}

export default Index;


// WEBPACK FOOTER //
// ./src/components/Home/_index.js